/**
 * Checks if the variable is one of the arguments passed to it
 */
function isIn <T = any>(varToCheck: any, ...values: T[]): boolean {

  for (const value of values) {

    if (varToCheck === value) return true

  }

  return false

}

export default isIn
